import { useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";

type Props = {
  totalRecords: number;
  pageLimit: number;
  pageNeighbours: number;
  onPageChanged: (page: number, totalPages: number) => void;
  currentPage: number;
  maxPages?: number;
};

export default function CustomPagination(props: Props) {
  const { pageNeighbours = 1, maxPages, onPageChanged, currentPage } = props;
  const [totalPages, setTotalPages] = useState<number>(0);

  useEffect(() => {
    const pageLimit = typeof props.pageLimit === "number" ? props.pageLimit : 25;
    const totalRecords = typeof props.totalRecords === "number" ? props.totalRecords : 0;

    let calculatedTotalPages = Math.ceil(totalRecords / pageLimit);

    if (maxPages !== undefined) {
      calculatedTotalPages = Math.min(calculatedTotalPages, maxPages);
    }

    setTotalPages(calculatedTotalPages);
  }, [props.totalRecords, props.pageLimit, maxPages]);

  function goToPage(page: number): void {
    const newPage = Math.max(1, Math.min(page, totalPages));
    onPageChanged(newPage, totalPages);
  }

  function generatePages(current: number, total: number): (number | 'LEFT' | 'RIGHT')[] {
    const pages: (number | 'LEFT' | 'RIGHT')[] = [];

    // Se poche pagine, le mostriamo tutte
    if (total <= 5) {
      for (let i = 1; i <= total; i++) {
        pages.push(i);
      }
      return pages;
    }

    const siblings = Math.max(1, Math.min(pageNeighbours, 2));

    const startPage = Math.max(2, current - siblings);
    const endPage = Math.min(total - 1, current + siblings);

    pages.push(1);

    if (startPage > 2) {
      pages.push('LEFT');
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < total - 1) {
      pages.push('RIGHT');
    }

    if (total > 1) {
      pages.push(total);
    }

    return pages;
  }


  return (
      <Pagination>
        {generatePages(currentPage, totalPages).map((page, index) => {
          if (page === 'LEFT' || page === 'RIGHT') {
            return (
                <Pagination.Ellipsis
                    key={`ellipsis-${index}`}
                    className="disabled"
                />
            );
          }

          return (
              <Pagination.Item
                  key={`page-${page}`}
                  active={page === currentPage}
                  onClick={() => goToPage(Number(page))}
              >
                {page}
              </Pagination.Item>
          );
        })}
      </Pagination>
  );
}
